import { bl_fi_mst_item_image_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialItemImageHdrContainer extends BaseContainerModel {
    bl_fi_mst_item_image_hdr: bl_fi_mst_item_image_hdr_RowClass = new bl_fi_mst_item_image_hdr_RowClass();
}

